import BaseEntity from "../base/BaseEntity";
import Tank from "../tank/Tank";
import Filter from "../base/Filter";

let Status = {
	OK: "OK",
	DISABLED: "DISABLED"
};

let StatusMap = {
	OK: {
		name: "生效",
		value: "OK",
		style: "success"
	},
	DISABLED: {
		name: "未生效",
		value: "DISABLED",
		style: "danger"
	}
};

let StatusList = [];
for (let key in StatusMap) {
	StatusList.push(StatusMap[key]);
}


export default function Carousel() {

	//extend BaseEntity's Attributes.
	BaseEntity.call(this, arguments);

	this.name = null;
	//Tank Object
	this.image = new Tank("image", false);
	this.description = null;
	this.url = null;
	this.showName = true;
	this.status = null;

	this.addTankConstrain();
}


//extend BaseEntity
Carousel.prototype = new BaseEntity();
Carousel.prototype.constructor = Carousel;
Carousel.prototype.TAG = "carousel";
Carousel.prototype.TAGS = "carousels";
Carousel.prototype.URL_PAGE = "/carousel/page";
Carousel.prototype.URL_DETAIL = "/carousel/detail/{id}";
Carousel.prototype.URL_CREATE = "/carousel/create";
Carousel.prototype.URL_EDIT = "/carousel/edit";
Carousel.prototype.URL_DEL = "/carousel/del/{id}";
Carousel.prototype.URL_STATUS = "/carousel/status";

Carousel.prototype.getFilters = function () {
	return [
		new Filter("SORT", "ID", "orderId"),
		new Filter("INPUT", "关键字", "keyword"),
		new Filter("INPUT", "名称", "name"),
		new Filter("SELECTION", "状态", "status", StatusList)
	];
}

Carousel.prototype.Status = Status;
Carousel.prototype.StatusMap = StatusMap;
Carousel.prototype.StatusList = StatusList;

//We use this method to get the full js Object.
Carousel.prototype.render = function (obj) {

	BaseEntity.prototype.render.call(this, obj);
	this.renderEntity("image", Tank);

	this.addTankConstrain();
}

Carousel.prototype.addTankConstrain = function () {
	this.image.maxSize = 1024 * 1024;
	this.image.uploadHint = "图片大小不超过1M";
}

Carousel.prototype.getForm = function () {

	let form = {
		name: this.name,
		imageCode: this.image.code,
		url: this.url,
		showName: this.showName
	};
	if (this.id) {
		form.id = this.id;
	}

	return form;

}


Carousel.prototype.validate = function () {
	//简单验证一下
	if (!this.name) {
		this.errorMessage = "标题必填！";
		return false;
	}

	if (!this.image.code) {
		this.errorMessage = "图片必填！";
		return false;
	}

	if (!this.url) {
		this.errorMessage = "url必填！";
		return false;
	}


	return true;
}

Carousel.prototype.httpStatus = function (status, successCallback, failureCallback) {


	this.httpPost(this.URL_STATUS, {"id": this.id, status}, successCallback, failureCallback);

	return true;
}




// WEBPACK FOOTER //
// ./src/common/model/carousel/Carousel.js